import { Injectable } from '@angular/core';
import { NgNavigatorShareService } from 'ng-navigator-share';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ShareService {
  openSharePopup$ = new BehaviorSubject<any>(null);
  title = '';
  text = '';
  url = '';
  description = '';
  platform= '';
  constructor(private ngNavigatorShareService: NgNavigatorShareService,) { }

  shareOnFacebook(url: string) {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`, '_blank');
  }

  shareOnTwitter(url: string, text: string) {
    window.open(`https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`, '_blank');
  }

  shareOnLinkedIn(url: string) {
    window.open(`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(url)}`, '_blank');
  }

  shareOnWhatsApp(url: string, text: string) {
    window.open(`https://wa.me/?text=${encodeURIComponent(text + ' ' + url)}`, '_blank');
  }

  shareOnMessenger(url: string) {
    window.open(`https://www.messenger.com/share?link=${encodeURIComponent(url)}`, '_blank');
  }

  shareOnGmail(url: string, title: string, body: string) {
    window.open(`https://mail.google.com/mail/?view=cm&fs=1&to=&su=${encodeURIComponent(title)}&body=${encodeURIComponent(body + ' ' + url)}`, '_blank');
  }

  shareOnInstagram(url: string) {
    // Instagram doesn't support direct sharing via URL. This could be a placeholder.
    window.alert('Instagram sharing is not supported directly.');
  }
  
  open(): void {
    this.openSharePopup$.next(true)
  }

  close(): void {
    this.openSharePopup$.next(false)
  }

  nativeShare() {
    this.ngNavigatorShareService.share({
      title: this.title,
      text: this.text,
      url: this.url
    }).then((response) => {
    })
      .catch((error) => {
        console.log(error);
      });
  }

  updateState(state: any) {
    console.log(state);
    this.title = state.title,
    this.text = state.text,
    this.url = state.url,
    this.platform = state.platform,
    this.description = state.description
    if(environment.isMoblie) {
      this.nativeShare()
    } else {
      this.share()
    }
  }

  share() {
    switch (this.platform) {
      case 'facebook':
        this.shareOnFacebook(this.url);
        break;
      case 'twitter':
        this.shareOnTwitter(this.url, this.text);
        break;
      case 'linkedin':
        this.shareOnLinkedIn(this.url);
        break;
      case 'whatsapp':
        this.shareOnWhatsApp(this.url, this.title);
        break;
      case 'messenger':
        this.shareOnMessenger(this.url);
        break;
      case 'gmail':
        this.shareOnGmail(this.url, this.title, this.text);
        break;
      case 'instagram':
        this.shareOnInstagram(this.url);
        break;
      case 'all':
        this.open();
        break;
      default:
        console.error('Unknown platform');
    }
  }

  getUrl() {
    return this.url;
  }

  getText() {
    return this.text;
  }

  getDescription() {
    return this.description;
  }
}
